import { render, staticRenderFns } from "./JobMobileCard.vue?vue&type=template&id=6bc07c8c&scoped=true&"
import script from "./JobMobileCard.vue?vue&type=script&lang=js&"
export * from "./JobMobileCard.vue?vue&type=script&lang=js&"
import style0 from "./JobMobileCard.vue?vue&type=style&index=0&id=6bc07c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc07c8c",
  null
  
)

export default component.exports